// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3OL4e","title":"FrontImage_title__2z2y_"};